import { MSP } from 'constants/organizationsType';
import { IOrgProfileFormValues } from 'types';
import {
  ICreateOrganizationBody,
  IOrganizationProfileRequestBody,
  IUpdateOrganizationBody,
} from 'types/api.type';
import { OrgTypeOption } from 'types/organizations.type';

export interface IOrganizationBodyOptions {
  orgType: OrgTypeOption | undefined;
  logo: string;
  id?: number | null;
  mspId?: number | null;
}

export const getOrganizationRequestBody = (
  values: IOrgProfileFormValues,
  options?: IOrganizationBodyOptions
): ICreateOrganizationBody | IUpdateOrganizationBody => {
  const { name, admins, street, city, state, zipCode, margin } = values;
  const { orgType, logo, id, mspId } = options || {};

  const baseBody: IOrganizationProfileRequestBody = {
    is_msp: orgType === MSP,
    name,
    address: {
      street,
      city,
      state,
      zip_code: zipCode,
    },
    admins,
    ...(margin && { margin: +margin }),
    ...(logo && { logo }),
    ...(mspId && { msp_id: mspId }),
  };

  if (id && typeof id === 'number') {
    return { ...baseBody, id } as IUpdateOrganizationBody;
  }
  return baseBody as ICreateOrganizationBody;
};

export const isServerError = (status: number) => {
  return status >= 500 && status <= 599;
};
